import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <>
      <div className="container-fluid footer bg-dark py-5 wow fadeIn" data-wow-delay="0.2s">
        <div className="container py-5">
          <div className="row g-5 mb-5 align-items-center">
            <div className="col-lg-7">
              <div className="position-relative mx-auto">
                <input className="form-control w-100 py-3 ps-4 pe-5" type="text"
                  placeholder="Email address to Subscribe" />
                <button type="button"
                  className="btn btn-primary position-absolute top-0 end-0 py-2 px-4 mt-2 me-2">Subscribe</button>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                <a className="btn btn-light btn-md-square me-3" href="#"><i className="fab fa-facebook-f"></i></a>
                <a className="btn btn-light btn-md-square me-3" href="#"><i className="fab fa-twitter"></i></a>
                <a className="btn btn-light btn-md-square me-3" href="#"><i className="fab fa-instagram"></i></a>
                <a className="btn btn-light btn-md-square me-0" href="#"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <div className="footer-item">

                  <img src="img/logo-small.png" alt="Logo" />
                  <p className="mb-3">Efficient wastewater recycling solutions that treat, recover, and reuse
                    water, reducing environmental impact and promoting sustainable resource management.</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Quick Links</h4>
                <Link to="/"> Home</Link>
                <Link to="/about"> About us</Link>
                <Link to="/water-treatment-plants"> Service</Link>
                <Link to="/about"> Testimonial</Link>
                <Link to="/contact"> Contact Us</Link>
              </div>
            </div>
            <div className="col-md-5 col-lg-5 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Our services</h4>
                <Link to="/design-and-consultancy"> Design & Engineering</Link>
                <Link to="/water-treatment-plants"> Water Treatment Plants</Link>
                <Link to="/cooling-towers-enc"> Cooling tower treatment design</Link>
                <Link to="/operation-and-maintenance"> Operation & Maintenance</Link>
                <Link to="/revamping-of-water-treatment-plants">Revamping of water treatment plants</Link>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 col-xl-4">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Contact Info</h4>
                <a href="https://maps.google.com/?q=G-219,RIICO+Industrial+Area,Palra,Ajmer" target="_blank" rel="noopener noreferrer"><i className="fa fa-map-marker-alt text-primary me-2"></i> G-219, RIICO Industrial Area,
                  Palra, Ajmer</a>
                <a href="mailto:wassertechnochem@hotmail.com"><i className="fas fa-envelope text-primary me-2"></i>
                  wassertechnochem@hotmail.com</a>
                <a href="mailto:info@wassertechnochem.com"><i className="fas fa-envelope text-primary me-2"></i>
                  info@wassertechnochem.com</a>
                <a href="tel:+917726010661"><i className="fas fa-phone text-primary me-2"></i> +91-7726010661</a>
                <a href="tel:+9101452690237" className="mb-0"><i className="fas fa-print text-primary me-2"></i>0145-2690237</a>
                <a href="tel:+9101452691456" className="mb-3"><i className="fas fa-print text-primary me-2"></i>0145-2691456</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body"><Link to="/" className="border-bottom text-white"><i
                className="fas fa-copyright text-light me-2"></i>WASSER TECHNOCHEM (I) LTD</Link>, All right
                reserved.</span>
            </div>
            <div className="col-md-6 text-center text-md-end text-body">

            </div>
          </div>
        </div>
      </div>




      <Link to="/" className="btn btn-primary btn-lg-square back-to-top"><i className="fa fa-arrow-up"></i></Link>

    </>
  );
};

export default Footer;
